import { StampView } from '@st/document-annotations'
import { HTMLSurface, Viewport } from '@st/document-rendering'
import { StampAnnotation } from '@st/sdk'

export function StampIconDisplay({ annotation }: { annotation: StampAnnotation }) {
  return (
    <div
      style={{
        position: 'relative',
        width: annotation.bounds.width,
        height: annotation.bounds.height
      }}
    >
      <Viewport
        Surface={HTMLSurface}
        width={annotation.bounds.width}
        height={annotation.bounds.height}
      >
        <StampView annotation={annotation} />
      </Viewport>
    </div>
  )
}
